import { Component, OnInit, ViewChild, HostListener, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ResultsService } from '../../../services/results.service';
import { CommonService } from 'src/app/services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { organizationDTO } from 'src/app/models/providersDTO';
import { providerDTO } from 'src/app/models/providersDTO';
import { MatAutocompleteTrigger } from '@angular/material';
import { startWith, map, switchMap, debounceTime } from 'rxjs/operators';
import { PersistenceService, StorageType } from 'angular-persistence';
import { Observable } from 'rxjs';
import { AgmMap, MouseEvent, MapsAPILoader } from '@agm/core';
import Swal from 'sweetalert2';
import { Pipe } from '@angular/core';
import { all } from 'q';
declare var $: any;
@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css']
})

export class ResultsComponent implements OnInit {
  contentPath = localStorage.getItem('ContentPath');
  include500Miles = localStorage.getItem('IncludeMiles500');
  public orgDetails: organizationDTO = new organizationDTO();
  chkPhysican: boolean = false;
  chkHospital: boolean = false;
  chkFacility: boolean = false;
  chkPharmacy: boolean = false;
  isCheckSpeciality: boolean = false;
  isCheckLanguage: boolean = false;
  public locSerachText: string = '';
  public planSerachText: string = '';
  hideChoosePlan: boolean = true;

  public quickSearch: string = '';
  public action: string = '';
  public tempAction: string = 'change';
  searchList: providerDTO[];
  searchListAll: providerDTO[];
  physicianSearchList: providerDTO[];
  hospitalSearchList: providerDTO[];
  facilitySearchList: providerDTO[];
  pharmacySearchList: providerDTO[];
  showList: providerDTO[];
  filterList: providerDTO[];
  filterData = [];
  filtersearch = [];
  searchProviderValue: string;
  latitude: number;
  longitude: number;
  getAddress: number;
  getCurrentLocation: any;
  radius: any = localStorage.getItem("Radius");
  totalCount: any;
  pageCount: any = localStorage.getItem('pageCount');
  activePage: number = 0;
  engcount: number = 0;
  spanishcount: number = 0;
  othercount: number = 0;
  displayCount: number = 0;
  showNoRecords: boolean = false;
  data: [];
  distinctspeciality = []
  distinctspecialities = []
  distinctLanguage = []
  distinctLanguages = []
  PhysicianCount: number = 0;
  HospitalCount: number = 0;
  FacilityCount: number = 0;
  ClinicCount: number = 0;
  showLocPopulate = true;
  Providername: string = "";
  changeLocationtext: boolean = false;
  changePlantext: boolean = false;
  actionType: string
  Specailitytype = [];
  Providerstype = [];
  Languagetype = [];
  dictionary = [];
  dictionaryList = [];
  languages = [];
  languagesList = [];
  isShowMoreLessSpeciality: boolean = true;
  isShowMoreLessLang: boolean = true;
  public locationform: FormGroup;
  srchlocationCtrl = new FormControl();
  srchProviderCtrl = new FormControl();
  public TempgridData: any[] = [];
  public autoLocationIntellegience: Observable<string[]>;
  public autoProviderIntellegience: Observable<string[]>;
  
  public locsearchtxt: string;
  locSerachText1: string;
  public planform: FormGroup;
  public providerform: FormGroup;
  srchplanCtrl = new FormControl();
  autoPlanIntellegience: any;
  interval:any;
  Wday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  day = new Date();
  TodayDay = this.Wday[this.day.getDay()];
  plansString:string =localStorage.getItem('Plans');
  plans:any[]=this.plansString.split(',');
  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger, static: false }) autoCompleteInput: MatAutocompleteTrigger;
  @ViewChild('searchtextvalue', { read: MatAutocompleteTrigger, static: false }) autoComplete: MatAutocompleteTrigger;
  @ViewChild('autoCompleteProvider', { read: MatAutocompleteTrigger, static: false }) autoCompleteProvider: MatAutocompleteTrigger;
  @ViewChild(AgmMap, { static: true }) public agmMap: AgmMap;
  public plnsearchtxt: string;
  allrecords:any[]=[];
  startpageIndex:number =parseInt( localStorage.getItem('pageCount'));
  isdisplayendmsg:boolean = false;
  topPosToStartShowing:number = 1000;

  constructor(private _renderer: Renderer2,private commonService: CommonService,private apiloader: MapsAPILoader, private router: Router, private formBuilder: FormBuilder, private resultsService: ResultsService, public activateRoute: ActivatedRoute, private spinner: NgxSpinnerService, private persistenceService: PersistenceService) {
    this.srchlocationCtrl = new FormControl();
    this.srchplanCtrl = new FormControl();
    this.srchProviderCtrl = new FormControl();
    this._renderer.removeStyle(document.body,'padding-right');
  }

  ngOnInit() {
    this.commonService.getOrganizationDetails().then((formdata) => {
      this.orgDetails = formdata[0];
    });
    this.searchList = [];
    this.LoadProviderData();
    this.spinner.show();
    this.locationform = this.formBuilder.group({
      searchtext: this.srchlocationCtrl,
    });
    this.planform = this.formBuilder.group({
      searchtext: this.srchplanCtrl,
    })
    this.providerform = this.formBuilder.group({
      searchtext: this.srchProviderCtrl,
    })

    this.refreshData();
    this.interval = setInterval(() => { 
        this.refreshData(); 
    }, 60000);

    //this.TempgridData=this.persistenceService.get('currentlocations',StorageType.SESSION);
    // this.resultsService.getNetworkZipCodes().subscribe((data: any[]) => {
    //   this.TempgridData = data;
    //   this.persistenceService.set('currentlocations', data, { type: StorageType.SESSION });
    // });
    // this.plans = this.persistenceService.get('currentplans', StorageType.SESSION);

    $(document).ready(function() {  
      $('body').click(function()
      {
        $('.collapse').removeClass('show');
      });    
    });

    
    


  }

@HostListener("window:scroll", [])
onScroll() {
  const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition >= this.topPosToStartShowing) {
  let nextcount=this.startpageIndex+parseInt(this.pageCount);
  //const length = this.posts.length
  if(this.allrecords){
  setTimeout(() => {
    this.showList=this.showList.concat(this.allrecords.slice(this.startpageIndex, nextcount ));
    this.startpageIndex = nextcount;
  }, 1000)
  this.topPosToStartShowing = this.topPosToStartShowing + 1000;
  }  }
  if(this.allrecords.length == this.showList.length && this.allrecords.length != 0 && this.showList.length != 0){
    this.isdisplayendmsg=true;
  }
  else{
    this.isdisplayendmsg=false;
  }
  this.displayCount = this.showList.length;
      if (this.displayCount == 0)
        this.showNoRecords = true;
}

  
  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  ValidateInput(e){
    var regex = new RegExp("^[0-9a-zA-Z_\. ]+$");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
            return true;
        }
        e.preventDefault();
        return false;
  }

  async refreshData()
  {
    this.resultsService.getNetworkZipCodes().subscribe((data: any[]) => {
      this.TempgridData = data;
      this.persistenceService.set('currentlocations', data, { type: StorageType.SESSION });
    });
    //this.plans = this.persistenceService.get('currentplans', StorageType.SESSION);
    this.persistenceService.set('currentplans',this.plans, { type: StorageType.SESSION });
  }

  LoadProviderData() {
    this.spinner.show();
    this.Providername = "";
    this.activateRoute.queryParams.subscribe(params => {
      if (params['sp'] != undefined && params['sp'] != "" && params['sp'] != null) {
        this.searchProviderValue = params['sp'];
      }
      else {
        this.searchProviderValue = "";
      }
      if(params['latitude'] == undefined)
        this.latitude=0;
      else
        this.latitude = params['latitude'];
      if(params['longitude'] == undefined)
        this.longitude=0;
      else
        this.longitude = params['longitude'];
      if(params['_planSearch'] == undefined)
        this.planSerachText="";
      else
        this.planSerachText = params['_planSearch']
      if(params['locsearch'] == undefined)
        this.locSerachText="";
      else
        this.locSerachText = params["locsearch"]

      if (this.actionType != null && this.actionType != undefined && this.actionType != '') {
        this.action = this.actionType;
      }
      else {
        this.action = params['_action']
      }

      if (params['_action'] == "change")
          this.action = "all";
      this.spinner.hide();
      this.getSearchResult(this.latitude, this.longitude, this.radius, this.planSerachText, this.action, this.searchProviderValue)
    })
  }

  async getSearchResult(latitude: number, longitude: number, radius: number, plnText: string, action: string, spValue: string) {
    this.spinner.show();
    this.searchList = [];
    this.searchListAll = [];
    this.physicianSearchList = [];
    this.hospitalSearchList = [];
	this.facilitySearchList = [];
    this.pharmacySearchList = [];

    this.showList = [];

    this.resultsService.getFacility(latitude, longitude, radius, plnText, spValue, 'Facility').then((formdata: providerDTO[]) => {
     debugger;
	  this.spinner.show();
      this.FacilityCount=0;
      if(formdata != undefined && formdata != null && formdata.length > 0)
      {
        this.FacilityCount = formdata.length;
        this.facilitySearchList = formdata;
        if (this.searchListAll != undefined && this.searchListAll.length != 0)
          this.searchListAll = this.searchListAll.concat(formdata);
        else
          this.searchListAll = formdata;
      }
      else{
        if(this.Providerstype != undefined && this.Providerstype.length > 0){
        const index: number = this.Providerstype.indexOf("Facility");
        if (index !== -1) {
          this.Providerstype.splice(index, 1);
        }
      }
      }
    });

	 this.resultsService.getFacility(latitude, longitude, radius, plnText, spValue, 'Hospital').then((formdata: providerDTO[]) => {
      debugger;
	  this.spinner.show();
      this.HospitalCount=0;
      if(formdata != undefined && formdata != null && formdata.length > 0)
      {
        this.HospitalCount = formdata.length;
        this.hospitalSearchList = formdata;
        if (this.searchListAll != undefined && this.searchListAll.length != 0)
          this.searchListAll = this.searchListAll.concat(formdata);
        else
          this.searchListAll = formdata;
      }
      else{
        if(this.Providerstype != undefined && this.Providerstype.length > 0){
        const index: number = this.Providerstype.indexOf("Hospital");
        if (index !== -1) {
          this.Providerstype.splice(index, 1);
        }
      }
      }
    });

    this.resultsService.getPharmacy(latitude, longitude, radius, plnText, spValue).then((formdata: providerDTO[]) => {
      debugger;
	  this.spinner.show();
      this.ClinicCount=0;
      if(formdata != undefined && formdata != null && formdata.length > 0)
      {
        this.ClinicCount = formdata.length;
        this.pharmacySearchList = formdata;
        if (this.searchListAll != undefined && this.searchListAll.length != 0)
          this.searchListAll = this.searchListAll.concat(formdata);
        else
          this.searchListAll = formdata;
      }
      else{
        const index: number = this.Providerstype.indexOf("Pharmacy");
        if (index !== -1) {
          this.Providerstype.splice(index, 1);
        }
      }
    });

    await this.resultsService.getProviders(latitude, longitude, radius, plnText, spValue).then((formdata: providerDTO[]) => {
	debugger
      this.spinner.show();
      this.PhysicianCount=0;
      if(formdata != undefined && formdata != null && formdata.length > 0)
      {
        this.physicianSearchList = formdata;
        if (this.searchListAll != undefined && this.searchListAll.length != 0)
          this.searchListAll = this.searchListAll.concat(formdata);
        else
          this.searchListAll = formdata;
        this.PhysicianCount = formdata.length;
      }
      else{
        const index: number = this.Providerstype.indexOf("Physician");
        if (index !== -1) {
          this.Providerstype.splice(index, 1);
        }
      }
    });

    

    this.spinner.show();
    setTimeout(() => {

      this.searchListAll = this.searchListAll.sort((a, b) => a.distanceinMiles > b.distanceinMiles ? 1 : -1);


      if(this.Providerstype != undefined && this.Providerstype.length > 0)
      {
        this.Providerstype.forEach(item => {          
          if(item == "Physician")
            this.chkPhysican = true;
          if(item == "Hospital")
            this.chkHospital = true;
		if(item == "Facility")
            this.chkFacility = true;
          if(item == "Pharmacy")
            this.chkPharmacy = true;
        });
        this.searchList = this.searchListAll;
      }
      else{
        this.Providerstype = [];

        if (action == 'all' || action == "change") {
          this.chkHospital = false; this.chkFacility = false; this.chkPhysican = false; this.chkPharmacy = false;
          this.searchList = this.searchListAll;
        }
        else if (action == 'provider') {
          this.chkHospital = false; this.chkFacility = false; this.chkPhysican = true; this.chkPharmacy = false;
          this.Providerstype.push("Physician");
          this.searchList = this.searchListAll.filter(x => x.providerType == "Physician");
        }
		else if (action == 'facility') {
  this.chkHospital = true;
  this.chkFacility = true;
  this.chkPhysican = false;
  this.chkPharmacy = false;

  this.Providerstype.push("Facility");
  this.Providerstype.push("Hospital");

  this.searchList = this.searchListAll.filter(x =>
    x.providerType == "Facility" || x.providerType == "Hospital"
  );
}
        else if (action == 'pharmacy') {
          this.chkHospital = false; this.chkFacility = false; this.chkPhysican = false; this.chkPharmacy = true;
          this.Providerstype.push("Pharmacy");
          this.searchList = this.searchListAll.filter(x => x.providerType == "Pharmacy");
        }

      }

      this.GetSpecialitiesList(this.searchList);
      this.GetLanguages(this.searchList);

      this.searchList = this.searchList.sort((a, b) => (a.providerName > b.providerName) ? 1 : ((b.providerName > a.providerName) ? -1 : 0));
      
      // if(this.latitude != undefined && this.latitude != 0 )
      //   this.searchList = this.searchList.sort((a, b) => a.distanceinMiles > b.distanceinMiles ? 1 : -1);
      
        
      this.loadProviderData(this.searchList);
      if(this.Providername != "" || (this.Specailitytype != undefined && this.Specailitytype.length != 0)
      || (this.Languagetype != undefined && this.Languagetype.length != 0))
      {
        this.finalFilterList();
      }
      this.autoCompleteProviders();
      // this.totalCount = this.searchList.length;
      // this.showList = this.searchList.slice(0, this.pageCount);
      // this.displayCount = this.showList.length;
      // if (this.displayCount == 0)
      //   this.showNoRecords = true;
      // this.spinner.hide();
    }, 2000);

  }

  loadProviderData(data)
  {
    if(this.latitude != undefined && this.latitude != 0 )
      data = data.sort((a, b) => a.distanceinMiles > b.distanceinMiles ? 1 : -1);
      
    this.totalCount = data.length;
      this.allrecords = data;
      this.showList = data.slice(0, this.pageCount);
      this.displayCount = this.showList.length;
      if (this.displayCount == 0)
        this.showNoRecords = true;
      this.spinner.hide();
  }

  displayActivePage(activePageNumber: number) {
    
    this.activePage = activePageNumber;
    if (this.filterList != undefined && this.filterList.length != 0) {
      this.showList = this.filterList.slice((this.pageCount) * (this.activePage - 1), this.pageCount * this.activePage);
    }
    else {
      this.showList = this.searchList.slice((this.pageCount) * (this.activePage - 1), this.pageCount * this.activePage);
    }
    this.displayCount = this.showList.length;
    if (this.displayCount == 0)
      this.showNoRecords = true;
  }
  
  changeRadius(ev) {
    this.spinner.show();
    this.radius = ev.target.value;
    this.action = "all";
    this.Providerstype = [];
    //this.action = 'pharmacy'
    //this.chkPharmacy = true;
    this.getSearchResult(this.latitude, this.longitude, this.radius, this.planSerachText, this.action, this.searchProviderValue)
    
    //this.LoadProviderData();
    //this.Resetfilter();
  }

  
  changeLocation() {
    this.get();
    if(this.persistenceService.get('currentlocations',StorageType.SESSION) != undefined
      && this.persistenceService.get('currentlocations',StorageType.SESSION) != null)
        this.TempgridData=this.persistenceService.get('currentlocations',StorageType.SESSION);
    else{
      this.resultsService.getNetworkZipCodes().subscribe((data: any[]) => {
        this.TempgridData = data;
        this.persistenceService.set('currentlocations', data, { type: StorageType.SESSION });
      });
    }
    this.changeLocationtext = true;
    this.changePlantext = false;
    this.Providername = "";
    this.autoCompleteLocations();
  }
  changePlan(planSerachText: string) {
    //this.locChangeText='';
    //this.Providername = "";
    this.changePlantext = true;
    this.changeLocationtext = false;
    this.autoCompletePlans();
  }
  ProviderFilter(Providertype, event) {
    debugger;
    this.Specailitytype=[];
    this.Languagetype=[];
    this.isShowMoreLessSpeciality = true;
    this.isShowMoreLessLang = true;
    if (Providertype == "Physician")
      this.chkPhysican = event.target.checked;
    if (Providertype == "Hospital")
      this.chkHospital = event.target.checked;
	if (Providertype == "Facility")
      this.chkFacility = event.target.checked;
    if (Providertype == "Pharmacy")
      this.chkPharmacy = event.target.checked;
    
    if (!this.Providerstype.find(x => x == Providertype)) {
      this.Providerstype.push(Providertype)
    }
    else {
      const index: number = this.Providerstype.indexOf(Providertype);
      if (index !== -1) {
        this.Providerstype.splice(index, 1);
      }
    }
    // if (this.Providerstype != undefined && this.Providerstype.length != 0) {
    //   this.filterList = []
    //   this.Providerstype.forEach(item => {
    //     var data = this.searchListAll.filter(x => x.providerType == item);
    //     if (data != null && data != undefined)
    //       data.forEach(item => {
    //         this.filterList.push(item);
    //       });
    //   });
    //   setTimeout(() => {
    //     var Listdata = null;
    //     this.searchList = this.filterList;
    //     Listdata = this.searchList.sort((a, b) => a.distanceinMiles > b.distanceinMiles ? 1 : -1);
    //     // Listdata = Listdata.sort((a, b) => a.distanceinMiles > b.distanceinMiles ? 1 : -1);
    //     this.totalCount = Listdata.length;
    //     this.showList = Listdata.slice(0, this.pageCount);
    //     this.displayCount = this.showList.length;
    //     if (this.displayCount == 0)
    //       this.showNoRecords = true;
    //     this.GetSpecialitiesList(Listdata);
    //     this.GetLanguages(Listdata);
    //   }, 1000);
    // }
    // else {
    //   this.totalCount = this.searchListAll.length;
    //   this.showList = this.searchListAll.slice(0, this.pageCount);
    //   this.displayCount = this.showList.length;
    //   if (this.displayCount == 0)
    //     this.showNoRecords = true;
    //   this.GetSpecialitiesList(this.searchListAll);
    //   this.GetLanguages(this.searchListAll);
    // }
    this.finalFilterList();

  }

  // GetLanguages(data: providerDTO[]) {
  //   this.engcount = 0;
  //   this.spanishcount = 0;
  //   this.othercount = 0;
  //   data.forEach(item => {
  //     var data = item.SpeakingLanguages.split(',');
  //     if (data.includes("English")) {
  //       this.engcount = this.engcount + 1;
  //     }
  //     if (data.includes("Spanish")) {
  //       this.spanishcount = this.spanishcount + 1;
  //     }
  //     if (!data.includes("Spanish") && !data.includes("English")) {
  //       this.othercount = this.othercount + 1;
  //     }
  //   });
  // }
  GetLanguages(data: providerDTO[]) {
    // this.engcount = 0;
    // this.spanishcount = 0;
    // this.othercount = 0;
    // data.forEach(item => {
    //   var data = item.SpeakingLanguages.split(',');
    //   if (data.includes("English")) {
    //     this.engcount = this.engcount + 1;
    //   }
    //   if (data.includes("Spanish")) {
    //     this.spanishcount = this.spanishcount + 1;
    //   }
    //   if (!data.includes("Spanish") && !data.includes("English")) {
    //     this.othercount = this.othercount + 1;
    //   }
    // });
    this.languages = [];
    this.languagesList = [];
    this.distinctLanguage = [];
    this.distinctLanguages = [];
    for (var i = 0; i < data.length; i++) {
      if (!this.distinctLanguage.find(x => x == data[i].SpeakingLanguages)) {
        this.distinctLanguage.push(data[i].SpeakingLanguages.trim())
      }
    }
    this.distinctLanguage = this.distinctLanguage.filter(function (el) {
      return el != "";
    });
    this.distinctLanguage.forEach(item => {
      var language = item.split(',').map(lang=>lang.trim());;
      language.forEach(item1 => {
        if (!this.distinctLanguages.find(x => x.trim() == item1.trim())) {
          this.distinctLanguages.push(this.trimming_fn(item1))
        }
      })
    });

    this.distinctLanguages = this.distinctLanguages.sort((a, b) => a > b ? 1 : -1);
    this.distinctLanguages.forEach(language => {
      var result = data.filter(x => x.SpeakingLanguages.includes(language));
      this.languagesList.push({
        key: language,
        value: result.length,
        selected: false
      })
      if(this.Languagetype != undefined && this.Languagetype != null && this.Languagetype.length > 0)
      {
        this.Languagetype.forEach(item => {       
          this.languagesList.forEach(lang => {
            if (lang.key == item) {
              lang.selected = true;
            }
            });
          });
      }     
      
    })
    if(this.isShowMoreLessLang == true)
      this.languages = this.languagesList.slice(0, 5);
    else
      this.languages = this.languagesList;
  }

  GetSpecialitiesList(data: providerDTO[]) {
    this.dictionary = [];
    this.dictionaryList = [];
    this.distinctspeciality = [];
    this.distinctspecialities = [];
    for (var i = 0; i < data.length; i++) {
      if (!this.distinctspeciality.find(x => x == data[i].Specialities)) {
        if(data[i].providerType.toLowerCase() == "pharmacy")
        {
          var speciality = data[i].Specialities.split(',').map(spl=>spl.trim());
          speciality.forEach(item1 => {
            if (!this.distinctspeciality.find(x => x == item1)) {
              this.distinctspeciality.push(this.trimming_fn(item1))
            }
          });
        }
        else{
          this.distinctspeciality.push(data[i].Specialities)
        }
        
      }
    }
    this.distinctspeciality = this.distinctspeciality.filter(function (el) {
      return el != "";
    });
    this.distinctspeciality.forEach(item => {
      //var speciality = item.split(',').map(spl=>spl.trim());
      // speciality.forEach(item1 => {
      // })
      if (!this.distinctspecialities.find(x => x == item)) {
        this.distinctspecialities.push(this.trimming_fn(item))
      }
    });

    this.distinctspecialities = this.distinctspecialities.sort((a, b) => a > b ? 1 : -1);

    this.distinctspecialities.forEach(speciality => {
      var result =[];
      data.forEach(item1 => {
        if(item1.providerType == "Pharmacy")
        {
          var data1 = item1.Specialities.split(',').map(spl=>spl.trim());;
          if (data1.includes(speciality)) {
            result.push(item1);
          }
        }
        else{
          if (item1.Specialities.includes(speciality)) {
            result.push(item1);
          }
        }
      })   

      //var result = data.filter(x => x.Specialities.includes(speciality));
      // this.map.set(speciality, result.length); 
      // this.dictionary.push({
      //   key: speciality,
      //   value: result.length
      // })
      //})
      this.dictionaryList.push({
        key: speciality,
        value: result.length,
        selected: false
      })
    })
    if(this.isShowMoreLessSpeciality == true)
      this.dictionary = this.dictionaryList.slice(0, 10);
    else
      this.dictionary = this.dictionaryList;
  }
  viewlessSpeciality() {
    this.isShowMoreLessSpeciality = true;
    this.dictionary = this.dictionaryList.slice(0, 10);;
  }
  viewmoreSpeciality() {
    this.isShowMoreLessSpeciality = false;
    this.dictionary = this.dictionaryList;
  }

  viewlessLanguage() {
    this.isShowMoreLessLang = true;
    this.languages = this.languagesList.slice(0, 5);;
  }
  viewmoreLanguage() {
    this.isShowMoreLessLang = false;
    this.languages = this.languagesList;
  }
  // this will remove only beginning and end of string whitespace.    
  trimming_fn(x) {
    return x ? x.replace(/^\s+|\s+$/gm, '') : '';
  };
  
  Resetfilter() {
	debugger;
    this.isdisplayendmsg = false;
    this.Providername = '';
    this.Providerstype = [];
    this.chkPhysican = false;
    this.chkHospital = false;
	this.chkFacility = false;
    this.chkPharmacy = false;
    this.filterList = [];
    this.Specailitytype = [];
    //this.LoadProviderData();
    this.Specailitytype = [];
    this.Languagetype = [];
    this.isShowMoreLessSpeciality = true;
    this.isShowMoreLessLang = true;
    this.dictionary.forEach(item => item.selected = false);
    this.languagesList.forEach(item => item.selected = false);
    this.searchList = this.searchListAll;
    this.totalCount = this.searchListAll.length;
    this.allrecords = this.searchListAll;
    this.showList = this.searchListAll.slice(0, this.pageCount);
    this.GetSpecialitiesList(this.searchListAll);
    this.GetLanguages(this.searchListAll);
    this.displayCount = this.showList.length;
    if (this.displayCount == 0)
      this.showNoRecords = true;

  }
  Clear() {
    this.changePlantext = false;
    this.changeLocationtext = false;
  }

  get planformControl() {
    return this.planform.controls;
  }

  public autoCompleteLocations() {

    this.autoLocationIntellegience = this.srchlocationCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(200),
      map(locaddress => {

        if (locaddress == undefined) {
          this.locSerachText = "Your Location";
        }
        if (locaddress != undefined && locaddress.length >= 2) {
          return this._filter(locaddress)
        }

      })
    );
  }
  public autoCompleteProviders() {

    this.autoProviderIntellegience = this.srchProviderCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(200),
      map(prov => {
        if (prov != undefined && prov.length >= 2) {
          return this._filterProvider(prov)
        }

      })
    );
  }
  closemat() {
    this.autoComplete.closePanel();
  }
  closeprovidermat() {
    this.autoCompleteProvider.closePanel();
  }
  openmat() {
    this.autoComplete.openPanel();    
  }
  openprovidermat() {
    this.autoCompleteProvider.openPanel();
  }
  private _filter(locaddress: string): any[] {
    const filterValue = locaddress;
    return this.TempgridData.filter(locaddress =>
      locaddress.city.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) == 0
      || locaddress.zipCode.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) == 0
      || locaddress.stateCode.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) == 0
      || locaddress.location.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) == 0
    ).sort((a, b) => (a.city > b.city) ? 1 : ((b.city > a.city) ? -1 : 0));
  }
  private _filterProvider(prov: string): any[] {
    const filterValue = prov;
    let provFilter = [];
      var lstFilter = this.searchListAll.filter(provider =>
        provider.providerName.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase())
      );
      lstFilter.forEach(item => {
        if (!provFilter.includes(item.providerName)) {
          provFilter.push(item.providerName);
        }
      });
      return provFilter;
  }
  closemat1() {
    this.autoCompleteInput.closePanel();
  }
  openmat1() {
    this.autoCompleteInput.openPanel();
  }
  private autoCompletePlans() {
    this.autoPlanIntellegience = this.srchplanCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(200),
      map(plan => {
        if (plan.length >= 2) {
          return this._filterPlans(plan)
        }
      })
    );
  }
  _filterPlans(val: string) {
    this.planSerachText = val;
    const filterValue = val;
    return val ? this.plans.filter(s => s.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.plans;
  }

  ChangeProvders() {
    //if ((this.planChangeText != undefined && this.planChangeText != null && this.planChangeText != "")
    //|| (this.locChangeText != undefined && this.locChangeText != null && this.locChangeText != "")) {
    debugger;
    this.searchListAll = [];
    this.changePlantext = false;
    this.changeLocationtext = false;
    if (this.locSerachText != "Your Location") {
      var loc = this.TempgridData.filter(locaddress => 
        //locaddress.zipCode.toLocaleLowerCase().indexOf(this.locSerachText.toLocaleLowerCase()) == 0
        locaddress.city.toLocaleLowerCase().indexOf(this.locSerachText.toLocaleLowerCase()) == 0
          || locaddress.zipCode.toLocaleLowerCase().indexOf(this.locSerachText.toLocaleLowerCase()) == 0
          || locaddress.stateCode.toLocaleLowerCase().indexOf(this.locSerachText.toLocaleLowerCase()) == 0
      );
      if(loc != undefined && loc.length > 0)
      {
        this.resultsService.getLatlons(loc[0].location).then((formdata) => {
          if (formdata != undefined && formdata.length > 0) {
            this.latitude = formdata[0].latitude;
            this.longitude = formdata[0].longitude;
          }
          else {
            this.latitude = 0;
            this.longitude = 0;
          }
        });
      }
      else{
        this.resultsService.getLatlons(this.locSerachText).then((formdata) => {
          if (formdata != undefined && formdata.length > 0) {
            this.latitude = formdata[0].latitude;
            this.longitude = formdata[0].longitude;
          }
          else {
            this.latitude = 0;
            this.longitude = 0;
          }
        });
      }
    }
    else {
      this.get();
    }

    setTimeout(() => {
      this.Resetfilter();
      if (this.action == "all" && this.tempAction == "all")
        this.tempAction = "change";
      else if (this.action == "all" && this.tempAction == "change")
        this.tempAction = "all";
      //if ((this.latitude != undefined && this.latitude != null && this.latitude != 0)) {
        //this.spinner.show();
        if(this.locSerachText != "")
        {
          //debugger;
        if ((this.latitude != undefined && this.latitude != null && this.latitude != 0)) {
          this.router.navigate(['/results'], { queryParams: { sp:this.searchProviderValue, locsearch: this.locSerachText, latitude: this.latitude, longitude: this.longitude, _planSearch: this.planSerachText, _action: this.tempAction } });
        }
        else {
          this.changeLocationtext = true;
          this.spinner.hide();
          Swal.fire({
            title: 'Something went wrong!',
            text: 'Please try again with valid location!',
            icon: 'error'
          })
        }
      }
      else
      {
        this.router.navigate(['/results'], { queryParams: { sp:this.searchProviderValue, locsearch: this.locSerachText, latitude: this.latitude, longitude: this.longitude, _planSearch: this.planSerachText, _action: this.tempAction } });
      }
    }, 1000);
    this.topPosToStartShowing = 1000;
    this.startpageIndex =parseInt(this.pageCount);
  }

  public get() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.getAddress = (this.latitude, this.longitude)
          console.log(position)
          this.apiloader.load().then(() => {
            let geocoder = new google.maps.Geocoder;
            let latlng = {
              lat: this.latitude,
              lng: this.longitude
            };
            geocoder.geocode({
              'location': latlng
            }, function (results) {
              if (results[0]) {
                this.currentLocation = results[0].formatted_address;
                this.locSerachText = this.currentLocation;
                //console.log(this.assgin);  
              } else {
                //console.log('Not found');  
              }
            });
          });
        }
      })
    }
    else {
      alert("Location is not supported by this browser");
    }
  }

  searchProvderByName() {
    this.finalFilterList();
  }

  providerNameFilter()
  {
    
    this.filterData=[];
    if (this.Providername != '' && this.Providername != undefined && this.Providername != null) {
      if (this.filterList != null && this.filterList  != undefined && this.filterList.length > 0)
      {
        this.filterList.forEach(item => {
          if (item.providerName.toLowerCase().includes(this.Providername.toLowerCase())
          || (item.PhoneNumber.toLowerCase().includes(this.Providername.toLowerCase()))
          || (item.SpeakingLanguages.toLowerCase().includes(this.Providername.toLowerCase()))
          ) {
            this.filterData.push(item);
          }
        });
        this.filterList = this.filterData;
      }
      // else{
      //   this.searchListAll.forEach(item => {
      //   if (item.providerName.toLowerCase().includes(this.Providername.toLowerCase())) {
      //     this.filterData.push(item);
      //   }
      // });
      //   this.filterList = this.filterData;
      // }
    }
  }

  specialityFilter()
  {
    if (this.Specailitytype != undefined && this.Specailitytype.length != 0) {
      if (this.filterList != null && this.filterList  != undefined && this.filterList.length > 0)
      {
        let tempFilterList = this.filterList;
        this.filterList =[];
        this.Specailitytype.forEach(item => {  
          tempFilterList.forEach(item1 => {
              
              //var data = item1.Specialities.split(',').map(spl=>spl.trim());
              if (item1.Specialities.includes(item)) {
                if(!this.filterList.includes(item1))
                  this.filterList.push(item1);
              }
            })   
            // var data = tempFilterList.filter(x => x.Specialities.includes(item));
            // if (data != null && data != undefined)
            //   data.forEach(item => {
            //   this.filterList.push(item);
            // })
            this.dictionaryList.forEach(speciality => {
              if (speciality.key == item) {
                speciality.selected = true;
              }
            });

        });
      }
      else{
        this.Specailitytype.forEach(item => {   
          this.searchList.forEach(item1 => {
            //var data = item1.Specialities.split(',').map(spl=>spl.trim());;
            if (item1.Specialities.includes(item)) {
              if(!this.filterList.includes(item1))
                this.filterList.push(item1);
            }
          })     
          // var data = this.searchList.filter(x => x.Specialities.includes(item));
          // if (data != null && data != undefined)
          // data.forEach(item => {
          //   this.filterList.push(item);
          // })
          this.dictionaryList.forEach(speciality => {
            if (speciality.key == item) {
              speciality.selected = true;
            }
          });
      });
      }  
    }
  }

  languageFilter()
  {
    
    if (this.Languagetype != undefined && this.Languagetype.length != 0) {
      if (this.filterList != null && this.filterList  != undefined && this.filterList.length > 0)
      {
        let tempList = this.filterList;
        this.filterList = [];
        this.Languagetype.forEach(item => {
          tempList.forEach(item1 => {
            var data = item1.SpeakingLanguages.split(',').map(lang=>lang.trim());;
            if (data.includes(item) || data.includes(this.Providername)) {
              if(!this.filterList.includes(item1))
                this.filterList.push(item1);
            }
            if (item == "other") {
              if (!data.includes("english") && !data.includes("spanish"))
                if(!this.filterList.includes(item1))
                  this.filterList.push(item1);
            }
          })          
        });
      }
      else{
        this.Languagetype.forEach(item => {
          this.searchList.forEach(item1 => {
            var data = item1.SpeakingLanguages.split(',').map(lang=>lang.trim());;
            if (data.includes(item)) {
              if(!this.filterList.includes(item1))
                this.filterList.push(item1);
            }
            if (item == "other") {
              if (!data.includes("english") && !data.includes("spanish"))
              if(!this.filterList.includes(item1))
                  this.filterList.push(item1);
            }
          })          
        });
      }
    }
  }

  FilterBySpeciality(type, event) {
    
    if (event.target.checked == true) {
      this.filterList = []
      if (event.target.name == 'dictionary') {
        this.isCheckSpeciality = true
      }
      if (this.isCheckSpeciality) {
        event.target.checked = true
      }
      const checked = event.target.checked;
      this.dictionaryList.forEach(item => {
        if (item.key == type) {
          item.selected = checked
        }
      });
    }
    else {
      this.filterList = []
      const checked = event.target.checked;
      this.dictionaryList.forEach(item => {
        if (item.key == type) {
          item.selected = checked
        }
      });
    }
    if (!this.Specailitytype.find(x => x == type)) {
      this.Specailitytype.push(type)
    }
    else {
      const index: number = this.Specailitytype.indexOf(type);
      if (index !== -1) {
        this.Specailitytype.splice(index, 1);
      }
    }
    this.finalFilterList();
  }

  FilterByLanguage(language, event) {
    
    if (event.target.checked == true) {
      if (event.target.name == 'languages') {
        this.isCheckLanguage = true
      }
      if (this.isCheckSpeciality) {
        event.target.checked = true
      }
      const checked = event.target.checked;
      this.languagesList.forEach(item => {
        if (item.key == language) {
          item.selected = checked
        }
      });
    }
    else {
      const checked = event.target.checked;
      this.languagesList.forEach(item => {
        if (item.key == language) {
          item.selected = checked
        }
      });
    }
    if (!this.Languagetype.find(x => x == language)) {
      this.Languagetype.push(language)
    }
    else {
      const index: number = this.Languagetype.indexOf(language);
      if (index !== -1) {
        this.Languagetype.splice(index, 1);
      }
    }
    this.finalFilterList();
  }


  finalFilterList() {
    debugger;
    this.spinner.show();
    this.filterList = [];

    if (this.Providerstype != undefined && this.Providerstype.length != 0) {
      this.Providerstype.forEach(item => {
        var data = this.searchListAll.filter(x => x.providerType == item);
        if (data != null && data != undefined)
          data.forEach(item => {
            this.filterList.push(item);
          });
        if(item == "Physician")
          this.chkPhysican = true;
        if(item == "Hospital")
          this.chkHospital = true;
		if(item == "Facility")
          this.chkFacility = true;
        if(item == "Pharmacy")
          this.chkPharmacy = true;
      });
    }
    else{
      this.filterList = this.searchListAll;
    }

    this.GetSpecialitiesList(this.filterList);
    this.GetLanguages(this.filterList);
    
    
    //Provider Name Filter
    if (this.Providername != '' && this.Providername != undefined && this.Providername != null) {
      this.providerNameFilter(); 
    }

    //Speciality Filter From the above result
    if(this.filterList != undefined && this.filterList != null && this.filterList.length > 0)
    {
      this.spinner.show();
      this.specialityFilter();
      this.spinner.hide();
    }

    //Language Filter From the above result
    if(this.filterList != undefined && this.filterList != null && this.filterList.length > 0)
    {
      this.languageFilter(); 
      if(this.Languagetype != undefined && this.Languagetype.length > 0)
      {
      this.Languagetype.forEach(item => {       
        this.languages.forEach(lang => {
          if (lang.key == item) {
            lang.selected = true;
          }
          });
        });
      }
    }
      
    
    //setTimeout(() => {
    var Listdata = null;
    this.showList = [];
    Listdata = this.filterList.sort((a, b) => a.distanceinMiles > b.distanceinMiles ? 1 : -1);;
    this.totalCount = Listdata.length; 
    this.allrecords = Listdata;    
    this.showList = Listdata.slice(0, this.pageCount);
    if(this.allrecords.length == this.showList.length && this.allrecords.length != 0 && this.showList.length != 0){
      this.isdisplayendmsg=true;
    }
    else{
      this.isdisplayendmsg=false;
    }   
    this.displayCount = this.showList.length;
    if (this.displayCount == 0)
      this.showNoRecords = true;
    
      this.spinner.hide();
    //},1000);
    this.topPosToStartShowing = 1000;
    this.startpageIndex =parseInt(this.pageCount);
  }
  
  


}
